import { Menu } from 'antd'
import { ThreeDotsMenu } from '../../../../components/ThreeDotsMenu'
import { Typography } from '../../../../components/Typography'
import { BTN_TXT } from '../../../../constants'
import { useFinancialsPopup } from 'features/Financials/Providers/FinancialsPopupProvider'
import { TRebatesTableType } from './types'
import { getCompleteRebatesPaymentData } from 'features/Financials/PaymentActions/CompleteRebatesPopup/api'
import { validateCompleteRebatesPaymentData } from 'features/Financials/PaymentActions/CompleteRebatesPopup/helpers'
import { useCallback } from 'react'

export const RebatesTableMenu = ({
  row,
  canCompleteRebatesPayment,
  canInitiateRebatesPayment
}: {
  row: TRebatesTableType
  canCompleteRebatesPayment: boolean
  canInitiateRebatesPayment: boolean
}) => (
  <ThreeDotsMenu className="actual-saving-menu">
    <RebatesTableMenuItems
      row={row}
      canCompleteRebatesPayment={canCompleteRebatesPayment}
      canInitiateRebatesPayment={canInitiateRebatesPayment}
    />
  </ThreeDotsMenu>
)

const RebatesTableMenuItems = ({
  row,
  canCompleteRebatesPayment,
  canInitiateRebatesPayment
}: {
  row: TRebatesTableType
  canCompleteRebatesPayment: boolean
  canInitiateRebatesPayment: boolean
}) => {
  const { confirmRebatesPaymentPopup, completeRebatesPaymentPopup } =
    useFinancialsPopup()

  const onCompleteRebatesPayment = useCallback(async () => {
    const { data: completeRebatesPaymentData } =
      await getCompleteRebatesPaymentData(row.uuid)
    const isValid = validateCompleteRebatesPaymentData(
      completeRebatesPaymentData
    )
    if (isValid) {
      completeRebatesPaymentPopup.actions.open({
        row,
        completeRebatesPaymentData
      })
    }
  }, [completeRebatesPaymentPopup.actions, row])

  return (
    <Menu className="menu-items-wrapper actual-savings-menu" selectedKeys={[]}>
      {canInitiateRebatesPayment && (
        <Menu.Item
          key="pay"
          onClick={() => confirmRebatesPaymentPopup.actions.open({ row })}
        >
          <Typography.Body1>{BTN_TXT.PAY}</Typography.Body1>
        </Menu.Item>
      )}
      {canCompleteRebatesPayment && (
        <Menu.Item key="complete_rebates" onClick={onCompleteRebatesPayment}>
          <Typography.Body1>{BTN_TXT.COMPLETE_REBATES}</Typography.Body1>
        </Menu.Item>
      )}
    </Menu>
  )
}
